export function safeErrorDetails(error) {
    if (error instanceof Error && typeof error === "object") {
        const details = {
            status: "status" in error && typeof error.status === "number"
                ? error.status
                : undefined,
            category: "category" in error && typeof error.category === "string"
                ? error.category
                : undefined,
            code: "code" in error && typeof error.code === "string"
                ? error.code
                : undefined,
            logId: "logId" in error && typeof error.logId === "string"
                ? error.logId
                : undefined,
            systemLogId: "systemLogId" in error && typeof error.systemLogId === "string"
                ? error.systemLogId
                : undefined,
        };
        if (details.status !== undefined || details.category !== undefined) {
            return {
                name: error.name,
                ...(details.status !== undefined ? { status: details.status } : {}),
                ...(details.category !== undefined
                    ? { category: details.category }
                    : {}),
                ...(details.code ? { code: details.code } : {}),
                ...(details.logId ? { logId: details.logId } : {}),
                ...(details.systemLogId ? { systemLogId: details.systemLogId } : {}),
            };
        }
    }
    if (error instanceof Error) {
        return {
            name: error.name,
        };
    }
    return {
        name: error instanceof Error ? error.name : "UnknownError",
    };
}
//# sourceMappingURL=error-details.js.map